export default __webpack_public_path__ + "static/media/include_1@3x.a4438ce8.jpg";